import { useEffect, useState } from 'react';
import {
  getPublicPrograms,
  programFormPath,
  type PublicProgramApplication,
} from '@/lib/programs';

// Bir programın panelden YAYINLANMIŞ başvuru formunu döndürür.
//
// Liste tüm site için tek sefer çekilir ve modül düzeyinde saklanır (aynı anda
// açılan birden çok kart/sayfa tek istek yapar). Ağ hatasında sessizce "başvuru
// yok" kabul edilir — tanıtım sayfası hatasız açılmaya devam etsin diye.

let cache: Promise<Map<string, PublicProgramApplication>> | null = null;

function load(): Promise<Map<string, PublicProgramApplication>> {
  if (!cache) {
    cache = getPublicPrograms()
      .then((r) => new Map(r.programs.map((p) => [p.slug, p])))
      .catch(() => new Map<string, PublicProgramApplication>());
  }
  return cache;
}

export type ProgramApplicationState = {
  loading: boolean;
  // Yayında bir başvuru formu varsa site içi adresi, yoksa undefined.
  applyPath?: string;
  formTitle?: string;
};

export function useProgramApplication(
  slug: string | undefined,
): ProgramApplicationState {
  const [state, setState] = useState<ProgramApplicationState>({
    loading: true,
  });

  useEffect(() => {
    if (!slug) {
      setState({ loading: false });
      return;
    }
    let alive = true;
    void load().then((map) => {
      if (!alive) return;
      const found = map.get(slug);
      setState({
        loading: false,
        applyPath: found ? programFormPath(found.formId) : undefined,
        formTitle: found?.formTitle,
      });
    });
    return () => {
      alive = false;
    };
  }, [slug]);

  return state;
}
